export interface PropStrength {
  _id: string;
  rarity: number;
  [type: number]: number;
}

export const DEFAULT_PROP_STRENGTH_TABLE: Record<number, Record<number, number>> = {
  1: { 1: 4, 2: 8, 3: 10 },
  2: { 1: 8, 2: 16, 3: 20 },
  3: { 1: 40, 2: 80, 3: 100 },
  4: { 1: 120, 2: 240, 3: 300 },
};

export function createDefaultPropStrengthRows(
  rarities: Array<{ value: number | string }>,
  types: Array<{ value: number | string }>,
) {
  return rarities.map((rarity) => {
    const rarityValue = Number(rarity.value);
    const row: Omit<PropStrength, "_id"> = { rarity: rarityValue };
    types.forEach((type) => {
      const typeValue = Number(type.value);
      row[typeValue] = DEFAULT_PROP_STRENGTH_TABLE[rarityValue]?.[typeValue] ?? 0;
    });
    return row;
  });
}
